module.exports = __webpack_public_path__ + "img/neutral.ecb642c1.svg";